import { Box, CardMedia, styled } from "@mui/material";
import { useState } from "react";
import { PinnacleVideoThumbnailProps } from "./PinnacleVideoThumbnail.types";

const ZoomImage = styled(CardMedia)(({ theme }) => ({
    width: '100%',
    height: 'auto',
    borderRadius: theme.shape.borderRadius,
    transition: "transform 0.3s ease-in-out",
}));

const PinnacleVideoThumbnail: React.FC<PinnacleVideoThumbnailProps> = ({ src, alt, zoomEnabled }) => {
    const [isError, setIsError] = useState(false);

    return isError ? (
        <Box
            sx={{
                width: '100%',
                height: '120px',
                backgroundColor: '#eee',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#888',
                fontSize: 14,
                borderRadius: '12px',
            }}
        >
            Image unavailable
        </Box>
    ) : (
        zoomEnabled ? (
            <ZoomImage
                as="img"
                src={src}
                onError={() => setIsError(true)}
            />
        ) : (
            <img
                src={src}
                alt={alt}
                style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '12px' }}
                onError={() => setIsError(true)}
            />
        )
    );
};

export default PinnacleVideoThumbnail;